import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import Button from '../Button/Button.js';
import { COLOR, VARIANT } from '../constants/common.js';
import Checkbox from '../Checkbox/Checkbox.js';
import BasicDialog from '../Dialog/BasicDialog.js';
import { BannerContainer, ActionButton, IconWrapper, DialogWrapper } from './Banner.style.js';
function Banner(_ref) {
  let {
    show,
    message,
    onClickCloseIcon,
    buttonText,
    onButtonClick,
    showDialog = false,
    dialogOpen,
    setDialogOpen,
    dialogTexts,
    onClickConfirmCloseBanner,
    dontShowBannerAgain,
    setDontShowBannerAgain,
    customStyle
  } = _ref;
  if (!show) return null;
  const {
    dialogTitle,
    dialogMessage,
    dialogBtnConfirmText,
    dialogBtnCancelText,
    dialogReminderText
  } = dialogTexts || {};
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(BannerContainer, {
    sx: _objectSpread2({}, customStyle)
  }, /*#__PURE__*/React__default.createElement(Box, {
    className: "banner-message"
  }, /*#__PURE__*/React__default.createElement(Box, {
    component: "i",
    className: "meta-crm-icon-ic_alert font-size-16",
    mr: "5px"
  }), message), /*#__PURE__*/React__default.createElement(Box, {
    className: "banner-actions"
  }, buttonText && /*#__PURE__*/React__default.createElement(ActionButton, {
    onClick: onButtonClick
  }, buttonText), /*#__PURE__*/React__default.createElement(IconWrapper, {
    onClick: onClickCloseIcon
  }, /*#__PURE__*/React__default.createElement("i", {
    className: "meta-crm-icon-ic_cancel font-size-24"
  })))), showDialog && /*#__PURE__*/React__default.createElement(BasicDialog, {
    open: dialogOpen,
    onClose: () => setDialogOpen(false),
    dialogRootStyle: {
      maxWidth: '435px'
    }
  }, /*#__PURE__*/React__default.createElement(DialogWrapper, null, dialogTitle && /*#__PURE__*/React__default.createElement(Box, {
    className: "dialog-title"
  }, dialogTitle), dialogMessage && /*#__PURE__*/React__default.createElement(Box, {
    className: "dialog-message"
  }, dialogMessage), /*#__PURE__*/React__default.createElement(Box, {
    className: "dialog-actions"
  }, dialogBtnConfirmText && /*#__PURE__*/React__default.createElement(Button, {
    className: "dialog-button",
    onClick: () => {
      setDialogOpen(false);
      onClickConfirmCloseBanner();
    }
  }, dialogBtnConfirmText), dialogBtnCancelText && /*#__PURE__*/React__default.createElement(Button, {
    className: "dialog-button",
    color: COLOR.INFO,
    variant: VARIANT.TEXT,
    onClick: () => setDialogOpen(false)
  }, dialogBtnCancelText)), dialogReminderText && /*#__PURE__*/React__default.createElement(Checkbox, {
    checked: dontShowBannerAgain,
    onChange: () => setDontShowBannerAgain(!dontShowBannerAgain),
    label: dialogReminderText
  }))));
}
Banner.propTypes = {
  show: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onClickCloseIcon: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
  onButtonClick: PropTypes.func,
  showDialog: PropTypes.bool,
  dialogOpen: PropTypes.bool,
  setDialogOpen: PropTypes.func,
  dialogTexts: PropTypes.shape({
    dialogTitle: PropTypes.string,
    dialogMessage: PropTypes.string,
    dialogBtnConfirmText: PropTypes.string,
    dialogBtnCancelText: PropTypes.string,
    dialogReminderText: PropTypes.string
  }),
  onClickConfirmCloseBanner: PropTypes.func,
  dontShowBannerAgain: PropTypes.bool,
  setDontShowBannerAgain: PropTypes.func,
  customStyle: PropTypes.objectOf(PropTypes.shape({}))
};
Banner.defaultProps = {
  buttonText: '',
  onButtonClick: () => {},
  showDialog: false,
  dialogOpen: false,
  setDialogOpen: () => {},
  dialogTexts: {},
  onClickConfirmCloseBanner: () => {},
  dontShowBannerAgain: false,
  setDontShowBannerAgain: () => {},
  customStyle: {}
};
export { Banner as default };